export default "__VITE_ASSET__DiTq9R$r__"